'use strict';
var parent = require('../../stable/object/values');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/actual/object/values.js
// module id = 334
// module chunks = 0